import BugCommentRepositoryInterface from '@/services/Bug-report/Bug-report/Comments/interfaces';
import { AxiosInstance } from 'axios';
import { BugReportCommentEntity } from '@fenix/bug-report-entities';

export default class BugCommentRepository implements BugCommentRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  public async createComment(bugReportId: number, body: string): Promise<BugReportCommentEntity> {
    const url = `bug-report/bugs/${bugReportId}/comment`;
    const res = await this.axios.post(url, { body });
    return res.data;
  }

  public async getAll(bugReportId: number, page?: number, take?: number, desc?: boolean): Promise<BugReportCommentEntity[]> {
    const url = `bug-report/bugs/${bugReportId}/comment?page=${page}&take=${take}&desc=${desc}`;
    const res = await this.axios.get(url);
    return res.data;
  }
}
